import loadScript from 'load-script';
import Logging from '~app/core/logging';
import { stateToZip, zipToState } from '~app/core/zip';
import { t } from "~app/AppBundleContext";
import { clearNodes, loadNodes, loadHeader } from './nodeList';
import { ActionCreators as UndoActionCreators } from 'redux-undo';

import { createMessage, startLoading, finishLoading, setAppVersion } from './app';
const log = Logging.getLogger('app.actions.drive');

const GOOGLE_SDK_URL = process.env.GOOGLE_SDK_URL;
const GOOGLE_DRIVE_API_CLIENT_ID = process.env.GOOGLE_DRIVE_API_CLIENT_ID;
const GOOGLE_DRIVE_API_SCOPES = process.env.GOOGLE_DRIVE_API_SCOPES;
const GOOGLE_DRIVE_API_DISCOVERY_DOCS = process.env.GOOGLE_DRIVE_API_DISCOVERY_DOCS;
const GOOGLE_DRIVE_UPLOAD_PATH = process.env.GOOGLE_DRIVE_UPLOAD_PATH;

export const DRIVE_API_LOADED = 'DRIVE_API_LOADED';
export const DRIVE_FILES_LISTED= 'DRIVE_FILES_LISTED';
export const GOOGLE_SIGN_IN = 'GOOGLE_SIGN_IN';

export function loadDriveApi(updateProgress) {
  return async (dispatch) => {
    await loadApiScript(GOOGLE_SDK_URL);
    await loadLibs();
    await initClient();
    dispatch({
      type: DRIVE_API_LOADED,
      isApiLoaded: true,
    });
    updateProgress();
  };
}

function loadApiScript(url) {
  return new Promise(function(resolve,reject){
    loadScript(url,function(err,script){
      if(err !== null) return reject(err);
      resolve(script);
    });
  });
}

function loadLibs(){
  return new Promise(function(resolve,reject){
    window.gapi.load('client:auth2', resolve);
  });
}

function initClient() {
  return window.gapi.client.init({
      clientId: GOOGLE_DRIVE_API_CLIENT_ID,
      discoveryDocs: [GOOGLE_DRIVE_API_DISCOVERY_DOCS],
      scope: GOOGLE_DRIVE_API_SCOPES,
    });
}

export function signIn() {
  return (dispatch) => {
    return window.gapi.auth2.getAuthInstance().signIn()
    .then(user=>{
      // Need to check the status here?
      // let response = window.gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse();
      dispatch({
        type: GOOGLE_SIGN_IN,
        isSignedIn: window.gapi.auth2.getAuthInstance().isSignedIn.get(),
      });
      return user;
    });
  };
}

export function listFiles() {
  return (dispatch) => {
    let drive = window.gapi.client.drive;
    return drive.files.list({
      'pageSize': 20, // What size is a reasonable limit?
      'fields': 'nextPageToken, files(id, name)',
      'spaces': 'appDataFolder',
    }).then(response => {
      let files = response.result.files;
      dispatch({
        type: DRIVE_FILES_LISTED,
        files: files,
      });
      return files;
    }).catch(e =>{
      log.error(e.error);
    });
  };
}

export function deleteFile(fileId) {
  return (dispatch) => {
    return window.gapi.client.request({
      'path': `https://www.googleapis.com/drive/v3/files/${fileId}`,
      'method': 'DELETE',
    });
    // Could handle response here
    // .then(response => {
    //   log.debug(response);
    // });
  };
}

export function loadProject(fileId) {
  return async (dispatch) => {

    dispatch(startLoading(t("loading-drive")));
    try {
      let drive = window.gapi.client.drive;

      let filedata = await drive.files.get({fileId, alt:'media'})
      .then(res => {
        return res.body;
      })
      .catch(e => {
        log.error(e.error);
      });

      // Unzip project file
      log.debug('Getting nodes from zip');
      var savedState = await dispatch(zipToState(filedata));
      log.debug(savedState.nodes);

      // Clear any existing nodes
      log.debug('Clearing nodes');
      dispatch(clearNodes());

      // Hydrate app store
      log.debug('Hydrating store');
      dispatch(loadNodes(savedState.nodes));
      dispatch(loadHeader(savedState.header));
      dispatch(setAppVersion(savedState.version));

      // Clear history so there's no undo
      log.debug('Clearing history');
      dispatch(UndoActionCreators.clearHistory());
      dispatch(createMessage(t("file-loaded"), "success"));
    }
    catch(error) {
      dispatch(createMessage(t("failed-load-drive"), "danger"));
    }
    dispatch(finishLoading());
  };
}

export function saveProject(filename) {
  return async (dispatch, getState) => {
    dispatch(startLoading(t("saving-drive")));

    try {
      let filedata = await dispatch(stateToZip());

      const boundary = '-------314159265358979323846';
      const delimiter = '\r\n--' + boundary + '\r\n';
      const close_delim = '\r\n--' + boundary + '--';

      const contentType = 'application/zip';

      let metadata = {
          name: filename,
          mimeType: contentType,
          parents:['appDataFolder'],
        };

      let multipartRequestBody =
          delimiter +
          'Content-Type: application/json\r\n\r\n' +
          JSON.stringify(metadata) +
          delimiter +
          'Content-Type: ' + contentType + '\r\n' +
          'Content-Transfer-Encoding: base64\r\n' +
          '\r\n' +
          filedata +
          close_delim;

      await window.gapi.client.request({
        'path': GOOGLE_DRIVE_UPLOAD_PATH,
        'method': 'POST',
        'params': {
          'uploadType': 'multipart',
        },
        'headers': {
          'Content-Type': 'multipart/related; boundary="' + boundary + '"',
        },
        'body': multipartRequestBody});

        dispatch(createMessage(t("file-saved-google"), "success"));
    }
    catch(error) {
      dispatch(createMessage(t("failed-save-google"), "danger"));
    }

    dispatch(finishLoading());
  };
}



// WEBPACK FOOTER //
// ./src/actions/drive.js